import { motion } from "framer-motion";
import { useAppStore } from "../store/useAppStore";

const StatCard = ({ title, value, prefix = "$", suffix = "", color = "text-white" }) => (
  <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 text-center hover:bg-white/10 transition-all">
    <p className="text-gray-400 text-sm uppercase tracking-wider font-mono">{title}</p>
    <p className={`text-2xl md:text-3xl font-bold mt-2 ${color}`}>
      {prefix}{typeof value === 'number' ? value.toLocaleString() : value}{suffix}
    </p>
  </div>
);

export const LiveMetrics = () => {
  const { metrics } = useAppStore();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto"
    >
      <StatCard
        title="Total Value Locked"
        value={metrics.tvl}
        color="text-white"
      />
      <StatCard
        title="Arbitrage Profits (30d)"
        value={metrics.arbProfit}
        color="text-emerald-400"
      />
      <StatCard
        title="Market Sentiment"
        value={(metrics.sentiment * 100).toFixed(0)}
        prefix=""
        suffix="%"
        color={metrics.sentiment > 0.6 ? "text-emerald-400" : "text-yellow-400"}
      />
    </motion.div>
  );
};